import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import FlexibleArrivalDateFilter from '../store/FlexibleArrivalDateFilter';
import FlexibleDurationFilter from '../store/FlexibleDurationFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import StayDurationTypeState from '../store/StayDurationTypeState';

export default class StayDurationToFlexibleArrivalConnector implements Observer {
    readonly #arrivalDepartureFilter: FlexibleArrivalDateFilter;

    readonly #flexibleDurationTypeFilter: FlexibleDurationFilter;

    private constructor(
        filter: FlexibleArrivalDateFilter,
        flexibleDurationTypeFilter: FlexibleDurationFilter
    ) {
        this.#arrivalDepartureFilter = filter;
        this.#flexibleDurationTypeFilter = flexibleDurationTypeFilter;
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof StayDurationTypeState)) {
            return;
        }

        this.#updateState(subject.type);
    }

    public static connect(): void {
        const state = StayDurationTypeState.getInstance();
        const filters = HouseSearchFilters.getInstance();
        const arrivalDepartureFilter = filters.get(FlexibleArrivalDateFilter.NAME) as
            | FlexibleArrivalDateFilter
            | undefined;
        const flexibleDurationTypeFilter = filters.get(FlexibleDurationFilter.NAME) as
            | FlexibleDurationFilter
            | undefined;

        if (!arrivalDepartureFilter || !flexibleDurationTypeFilter) return;

        const connector = new StayDurationToFlexibleArrivalConnector(
            arrivalDepartureFilter,
            flexibleDurationTypeFilter
        );
        state.attach(connector);
        connector.#updateState(state.type);
    }

    #updateState(type: string): void {
        this.#arrivalDepartureFilter.enabled = type === 'calendar';
        this.#flexibleDurationTypeFilter.enabled = type === 'flexible';
    }
}
